export default function reducer(state = {}) {
  return state;
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/store/modules/ImageCarousel.js